import styled from "@emotion/styled"
import { Button, IconButton, css } from "@mui/material"
import Link from "next/link"
import { Desktop, Mobile, PhoneCallIcon } from "ui"
import { slugify } from "utils/slugify"

const StyledContainer = styled(Button) <{ $selected: boolean, $width: number }>`
  min-width: 244px;
  ${(props) => props.$width && `width: ${props.$width}px`};
  background: rgb(255, 255, 255);
  padding: 12px;
  padding-inline-end: 0;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  height: 76px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  flex-shrink: 0;
  min-width: 244px;
  :focus-visible{
    border: 1px solid gray;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    min-height: 72px;
    width: auto;
    border-bottom: 0.67px dashed rgba(21, 62, 105, 0.3);
    margin: 0px 10px 0px 10px;
    padding: 8px 8px 10px 8px;
    display: flex;
    flex-direction: column;
    background: ${(props) =>
    props.$selected ? "rgba(236, 240, 243, 1)" : "#FFF"};
  }
  cursor: pointer;
  > div:last-child:not(:first-child) {
    align-self: flex-start;
    margin-top: -8px;
  }
  ${(props) => props.theme.breakpoints.down("sm")} {
    &:hover {
      background: rgb(255, 255, 255);
    }
  }
`
const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 100%;
  }
`


const StyledTitle = styled.h3<{ noMap?: boolean }>`
  white-space: nowrap;
  font-size: ${(p) => (p.noMap ? "24" : "16")}px;
  font-weight: 500;
  line-height: 22.4px;
  margin:0;
  color: rgba(0, 80, 201, 1);
  text-align:start;
`

const StyledBetween = styled.div<{ noMap?: boolean }>`
  display: flex;
  justify-content: ${(p) => (p.noMap ? "flex-start" : "space-between")};
  align-items: center;
  ${(p) =>
    p.noMap &&
    css`
      gap: 26px;
    `}

  ${(props) => props.theme.breakpoints.down("sm")} {
    justify-content: space-between;
  }
`
const StyledAddress = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: start;
`
const StyledPhoneNumber = styled(Link)`
  font-size: 12px;
  font-weight: 500;
  color:inherit;
  line-height: 18px;
  white-space: nowrap;
  text-decoration:none;
`

const StyledContainerList = styled.div<{ $selected: boolean; noMap?: boolean }>`
  min-height: 72px;
  width: auto;
  border-bottom: 0.67px dashed rgba(21, 62, 105, 0.3);
  margin: 0px 10.67px 0px 21.33px;
  padding: 8px 8px 10.67px 8px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  background: ${(props) =>
    props.$selected ? "rgba(236, 240, 243, 1)" : "#FFF"};
  ${(p) =>
    p.noMap &&
    css`
      gap: 10px;
      padding: 8px;
      margin: 0px 10.67px;
    `}
`
type Props = {
  selected: boolean
  title: string
  address: string
  phone: string | undefined
  withMap: boolean
  width?: number
  onClick?: () => void
}

function PazomatListItem({
  selected,
  title,
  address,
  phone,
  withMap,
  width,
  onClick,
}: Props) {

  return (
    <>
      {withMap ? (
        title &&
        <StyledContainer
          disableRipple
          $width={width || 0}
          $selected={selected}
          onClick={onClick}
          tabIndex={0}
          id={slugify(title)}
        >
          <StyledWrap>
            <StyledTitle>{title}</StyledTitle>
            <StyledBetween>
              {address &&
                <StyledAddress>{address}</StyledAddress>
              }
              {phone &&
                <Desktop>
                  <StyledPhoneNumber href={`tel:${phone}`} aria-label="צור קשר טלפוני">{phone}</StyledPhoneNumber>
                </Desktop>
              }
            </StyledBetween>
          </StyledWrap>
          {phone &&
            <Mobile>
              <Link href={`tel:${phone}`}>
                <IconButton>
                  <PhoneCallIcon />
                </IconButton>
              </Link>
            </Mobile>
          }
        </StyledContainer>
      ) : (
        <StyledContainerList $selected={selected} noMap>
          <StyledTitle noMap>{title}</StyledTitle>
          <StyledBetween noMap>
            {
              address &&
              <StyledAddress>{address}</StyledAddress>
            }
            {phone &&
              <StyledPhoneNumber href={`tel:${phone}`}>{phone}</StyledPhoneNumber>
            }
          </StyledBetween>
        </StyledContainerList>
      )}
    </>
  )
}

export default PazomatListItem
